import React from 'react';
import ReactMarkdown from 'react-markdown';
import cn from 'classnames';
import './SessionViewer.scss';

const GRADE_LABELS = ['', 'Poor', 'Below Average', 'Average', 'Good', 'Excellent'];

const SessionViewer = ({ session, onClose }) => {
  if (!session) return null;

  const rawConversation = session.conversation;
  const conversation = Array.isArray(rawConversation) ? rawConversation : typeof rawConversation === 'string' ? JSON.parse(rawConversation) : [];

  return (
    <div className='session-viewer-overlay' onClick={onClose}>
      <div className='session-viewer' onClick={e => e.stopPropagation()}>
        <div className='session-viewer-header'>
          <h3>Session Details</h3>
          <button className='close-btn' onClick={onClose}>
            ×
          </button>
        </div>

        <div className='session-meta'>
          <div className='meta-row'>
            <span className='meta-label'>Shopper</span>
            <span className='meta-value'>{session.testShopperName || '—'}</span>
          </div>
          <div className='meta-row'>
            <span className='meta-label'>Date</span>
            <span className='meta-value'>{session.createdAt ? new Date(session.createdAt).toLocaleString() : '—'}</span>
          </div>
          <div className='meta-row'>
            <span className='meta-label'>Messages</span>
            <span className='meta-value'>{session.messageCount || conversation.length}</span>
          </div>
          {session.humanGrade && (
            <div className='meta-row'>
              <span className='meta-label'>Rating</span>
              <span className='meta-value'>
                {'★'.repeat(session.humanGrade)}
                {'☆'.repeat(5 - session.humanGrade)} {GRADE_LABELS[session.humanGrade]}
              </span>
            </div>
          )}
          {session.isGoldenDataset && (
            <div className='meta-row'>
              <span className='meta-label'>Dataset</span>
              <span className='meta-value golden-badge'>Golden</span>
            </div>
          )}
          {session.humanNotes && (
            <div className='meta-row notes-row'>
              <span className='meta-label'>Notes</span>
              <span className='meta-value'>{session.humanNotes}</span>
            </div>
          )}
        </div>

        <div className='session-conversation'>
          {conversation.length === 0 ? (
            <div className='empty-conversation'>No messages in this session</div>
          ) : (
            conversation.map((msg, i) => (
              <div key={i} className={cn('session-message', msg.role)}>
                <div className='message-role'>{msg.role === 'assistant' ? 'Dispatcher' : 'Shopper'}</div>
                <div className='message-body'>{msg.role === 'assistant' ? <ReactMarkdown>{msg.content}</ReactMarkdown> : msg.content}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionViewer;
